import { Show } from "solid-js";

import { isDark, toggleTheme } from "~/lib/theme";

export function ThemeToggle() {
  return (
    <button
      type="button"
      class="btn btn-ghost btn-sm btn-square"
      aria-label={isDark() ? "Switch to light theme" : "Switch to dark theme"}
      title={isDark() ? "Switch to light theme" : "Switch to dark theme"}
      onClick={toggleTheme}
    >
      <Show
        when={isDark()}
        fallback={
          // Moon — shown when light theme is active (click → go dark).
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="w-5 h-5"
            aria-hidden="true"
          >
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z" />
          </svg>
        }
      >
        {/* Sun — shown when dark theme is active (click → go light). */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="w-5 h-5"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
        </svg>
      </Show>
    </button>
  );
}
